/**
 * @generated SignedSource<<b090570abc78639c9284d566d1ccd0a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type genericField_updateWorkItemAllFieldTypesActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly " $fragmentType": "genericField_updateWorkItemAllFieldTypesActionRenderer";
};
export type genericField_updateWorkItemAllFieldTypesActionRenderer$key = {
  readonly " $data"?: genericField_updateWorkItemAllFieldTypesActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"genericField_updateWorkItemAllFieldTypesActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "genericField_updateWorkItemAllFieldTypesActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "f482a17d9c275aafd154d3d2b7cc26e8";

export default node;
